import styled, { css } from "styled-components";
import { Chip, Badge } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";

interface CategoryContainerProps {
  shadowType: string;
}

export const CategoryContainer = styled.div<CategoryContainerProps>`
  position: relative;
  margin: auto 12px;
  overflow-x: hidden;
  width: calc(100% - 80px);
  &::before,
  &::after {
    content: "";
    display: none;
    position: absolute;
    top: 0;
    width: 50px;
    height: 100%;
    z-index: ${zIndex.drawer};
  }

  &::before {
    left: -1px;
    background-image: linear-gradient(
      to right,
      #1f2126,
      rgba(31, 33, 38, 0) 100%
    );
  }

  &::after {
    right: -1px;
    background-image: linear-gradient(
      to right,
      rgba(31, 33, 38, 0),
      #1f2126 100%
    );
  }

  ${(props) => {
    if (props.shadowType === "left") {
      return css`
        &::before {
          display: block;
        }
      `;
    }
    if (props.shadowType === "right") {
      return css`
        &::after {
          display: block;
        }
      `;
    }
    if (props.shadowType === "center") {
      return css`
        &::before,
        &::after {
          display: block;
        }
      `;
    }
  }};
`;

export const ChipContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  margin-right: auto;
  padding-right: 2px;
`;

export const MuiBadge = styled(Badge)`
  margin-left: 8px;

  .MuiBadge-dot {
    height: 4px;
    width: 4px;
    min-width: 4px;
  }

  .MuiBadge-anchorOriginTopRightRectangle {
    right: 14px;
    top: 8px;
  }
`;

export const MuiChip = styled(Chip)`
  &.active {
    color: #000;
    font-weight: bold;
    background-color: #ff5b5b;
  }
`;
